import { render, staticRenderFns } from "./user-activity.vue?vue&type=template&id=22811904&scoped=true&"
import script from "./user-activity.vue?vue&type=script&lang=js&"
export * from "./user-activity.vue?vue&type=script&lang=js&"
import style0 from "./user-activity.vue?vue&type=style&index=0&id=22811904&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22811904",
  null
  
)

export default component.exports